import React, { Component } from "react";
import Markdown from 'markdown-to-jsx';
import translate from "react-i18next/dist/commonjs/translate";

class SupportPageDetails extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { t } = this.props;
    return (
      <div className="container">
        <div className="informationContainer">
          <h4 className="primaryColorHeader">{t("support")}</h4>
          <p>{t("supportPageInitialText")}</p>
          <div className="row supportDetailsEnhanced">
            <div className="col-sm-6">
              {t("supportPageCustomerPortalHeader")}:
            </div>
            <div className="col-sm-6">
              <a href={t("supportPageCustomerSupportURL")} target="_blank">
                {t("supportPageCustomerSupportURL")}
              </a>
            </div>
          </div>
          <div className="row supportDetailsEnhanced">
            <div className="col-sm-6">{t("supportPagePhoneHeader")}:</div>
            <div className="col-sm-6">{t("supportPagePhoneNumber")}</div>
          </div>
          <br />
          <p>{t("supportPageTelephoneHours1")}</p>
          <p>{t("supportPageTelephoneHours2")}</p>
        </div>
        <div className="informationContainer">
          <h4 className="primaryColorHeader">
            {t("supportPageReportAProblemHeader")}
          </h4>

          <p><Markdown options={{ forceBlock: true }}>{t("supportPageReportAProblem1")}</Markdown></p>
          
        </div>

        <div className="informationContainer">
          <h4 className="primaryColorHeader">
            {t("supportPageRequestForChangeHeader")}
          </h4>

          <p><Markdown options={{ forceBlock: true }}>{t("supportPageRequestForChange1")}</Markdown></p>

          <p><Markdown options={{ forceBlock: true }}>{t("supportPageRequestForChange2")}</Markdown></p>

          <p><Markdown options={{ forceBlock: true }}>{t("supportPageRequestForChange3")}</Markdown></p>
          
        </div>

        <div className="informationContainer">
          <h4 className="primaryColorHeader">
            {t("supportPageEnhancementRequestHeader")}
          </h4>

          <p><Markdown options={{ forceBlock: true }}>{t("supportPageEnhancementRequest1")}</Markdown></p>

          <p><Markdown options={{ forceBlock: true }}>{t("supportPageEnhancementRequest2")}</Markdown></p>

          <p><Markdown options={{ forceBlock: true }}>{t("supportPageEnhancementRequest3")}</Markdown></p>
          
        </div>
      </div>
    );
  }
}

export default translate("translations")(SupportPageDetails);



// WEBPACK FOOTER //
// ./src/support/SupportPageDetails.js